import { ApolloError, DocumentNode, useLazyQuery } from "@apollo/client";

export const useLazyQueryWithCallbacks = <T, K = unknown>(
  mutation: DocumentNode,
  onSuccess?: (response: T) => void,
  onError?: (error: ApolloError) => void
) => {
  const [trigger, { loading, error, refetch }] = useLazyQuery<T, K>(mutation, {
    onCompleted(data) {
      if (onSuccess) onSuccess(data);
    },
    onError(error) {
      if (onError) onError(error);
    },
    notifyOnNetworkStatusChange: true,
    errorPolicy: "all",
  });

  return { trigger, loading, error, refetch };
};
